export const loadDocumentDetailSuccessAction = (state, info) => {
  return {
    ...state,
    ...info,
    isLoading: false,
    isError: false,
    errorMessage: null,
  }
}

export const loadDocumentDetailFailureAction = (state, info) => {
  return {
    ...state,
    isLoading: false,
    isError: true,
    errorMessage: info.error,
  }
}
